/**
 * Efast Workbench - 聊天模拟 + AI报价
 * 从 sales_logic.js 拆分
 */


/**
 * ==========================================
 * 3. 旺旺(TM) 即时聊天交互 (TM Live Chat Box)
 * ==========================================
 */
const chatData = {
    Dieter: {
        title: "Dieter Weber (德国 / 汉堡)",
        messages: [
            { type: "incoming", text: "Hi, I am interested in your car magnetic phone mounts (ZF71). Is the MOQ negotiable?", time: "09:55" },
            { type: "outgoing", text: "Hello Dieter, welcome! Yes, MOQ is negotiable for our initial trial partnership. How many units are you planning to order?", time: "09:58" },
            { type: "incoming", text: "Can we do the customized logo on silicon pad? We need about 2,000 units.", time: "10:05" }
        ]
    },
    Lars: {
        title: "Lars Janssen (荷兰 / 阿姆斯特丹)",
        messages: [
            { type: "incoming", text: "Hello Samson, we are planning our Q3 sourcing. Is the ZF72 model ready for shipment?", time: "昨天" },
            { type: "outgoing", text: "Hi Lars! Yes, the ZF72 is fully certified with CE and RoHS. The upgraded N52 magnets are super strong.", time: "昨天" },
            { type: "incoming", text: "Great. Please let me check with our retail team.", time: "昨天" }
        ]
    }
};

let currentChatId = "Dieter";

function initChat() {
    // 默认载入 Dieter 的聊天
    switchChat("Dieter");
}

function switchChat(chatId) {
    currentChatId = chatId;
    
    // 更新侧边栏 active 样式
    document.querySelectorAll(".thread-item").forEach(item => {
        item.classList.remove("active");
    });
    const activeThread = document.getElementById(`thread-${chatId.toLowerCase()}`);
    if (activeThread) activeThread.classList.add("active");

    // 加载数据
    const data = chatData[chatId];
    if (!data) return;

    const chatTitle = document.getElementById("chat-current-title");
    if (chatTitle) chatTitle.innerText = data.title;

    renderChatMessages();
}

function renderChatMessages() {
    const container = document.getElementById("chat-messages-container");
    if (!container) return;

    container.innerHTML = "";
    const data = chatData[currentChatId];

    data.messages.forEach(msg => {
        const div = document.createElement("div");
        div.className = `message ${msg.type}`;
        div.innerHTML = `
            <p>${msg.text}</p>
            <span class="msg-time">${msg.time}</span>
        `;
        container.appendChild(div);
    });

    container.scrollTop = container.scrollHeight;
}

function sendChatMessage() {
    const input = document.getElementById("chat-reply-input");
    if (!input || !input.value.trim()) return;

    const text = input.value.trim();
    const time = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

    // 添加到内存中
    chatData[currentChatId].messages.push({
        type: "outgoing",
        text: text,
        time: time
    });

    // 重新渲染聊天框
    renderChatMessages();
    input.value = "";

    // 仿真客户 1.5 秒后自动回复，增强即时交互感
    setTimeout(() => {
        let replyText = "";
        if (currentChatId === "Dieter") {
            replyText = "Thank you for the quick reply. Can you draft a Proforma Invoice (PI) for me to review the total costs including shipping?";
        } else {
            replyText = "Perfect, please send the specifications sheet to my email. I will review it today.";
        }

        chatData[currentChatId].messages.push({
            type: "incoming",
            text: replyText,
            time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
        });
        
        renderChatMessages();

        // 同时更新列表上的最后一条消息预览
        const lastMsgEl = document.querySelector(`#thread-${currentChatId.toLowerCase()} .last-msg`);
        if (lastMsgEl) {
            lastMsgEl.innerText = replyText;
        }

        // 如果是 Dieter，提示可以去“票据中心”开单了
        if (currentChatId === "Dieter") {
            alert(`💬 [阿里旺旺] 德国大客户 Dieter Weber 刚给您发了新消息：\n\n"${replyText}"\n\n系统提示：已为您自动推荐“票据生成中心”，请点击该板块快速为其开具形式发票 (PI) 锁定订金成单！`);
        }
    }, 1500);
}

/**
 * ==========================================
 * 4. AI 智能一键生成报价 (AI Quote Generator)
 * ==========================================
 */

function openAiQuote(buyerName, productName, inquiryText) {
    const modal = document.getElementById("ai-quote-modal");
    if (!modal) return;

    document.getElementById("ai-modal-buyer").innerText = buyerName;
    document.getElementById("ai-modal-product").innerText = productName;
    
    document.getElementById("ai-modal-inquiry").innerText = `"${inquiryText}"`;

    // 针对不同的客户定制不同话术 (融合深圳翼快科技的高阶外贸商务开发话术)
    let draftText = "";
    if (buyerName.includes("Dieter")) {
        draftText = `Dear ${buyerName},

Thank you for your high-value inquiry regarding our premium Car Magnetic Phone Holder (Model: ZF71).

Based on your requirement of 2,000 units with customized laser logo, here is our tailored executive proposal:

1. Premium Quality & Customization:
Our ZF71 car mounts use high-grade anodized aluminum alloy (not cheap plastic) with high-density silicone padding. We will laser-engrave your corporate logo on the silicone pad. Due to your batch order exceeding 1,500 units, we have waived the custom mold fee (USD $150 value) — this custom printing is FREE for you!

2. Direct FOB Price Quotation:
- Product Model: ZF71 Car Mount (Custom Laser Logo Version)
- Order Quantity: 2,000 units
- Exclusive FOB Shenzhen Price: USD $7.50 / Unit (MOQ price is $8.50, we applied a special $1.00 discount for our first partnership)
- Subtotal Amount: USD $15,000.00

3. Lead Time & Shipping:
Our current production line in Shenzhen is optimizing output this week. We guarantee to complete mass production within 12 working days upon deposit, ensuring you catch the end-of-month sea shipment to Hamburg.

4. Action Plan:
Would you like me to dispatch a physical custom sample with your laser logo for physical approval first? Or shall I draft a Trade Assurance order on Alibaba to lock the factory production slot directly?

Looking forward to your swift confirmation.

Best regards,

Samson Chiu
Sales Manager | B2B Consumer Electronics Specialist
Shenzhen Efast Technology Co., Ltd.
E-mail: samson@efast-tech.com
WhatsApp: +86 13560723375`;
    } else if (buyerName.includes("Lars")) {
        draftText = `Dear Lars,

It's wonderful to hear from you again! We deeply value our long-term partnership with you in the Netherlands.

Regarding your interest in our latest upgraded model ZF72 (with advanced N52 neodymium magnets and 15kg load capacity), here is the bulk pricing and CIF Rotterdam offer you requested:

1. Product Advantages:
The ZF72 features double the magnetic suction of the ZF71, with 360-degree rotation and a heavy-duty air vent clamp. It is fully CE, FCC, and RoHS certified for the EU marketplace.

2. Quotation (CIF Rotterdam):
- New Model: ZF72 Ultra Magnetic Vent Mount
- Batch Order: 2,000 units
- Standard Price: USD $9.50 / Unit
- Special VIP Price (10% Discount): USD $8.55 / Unit
- Local Shipping & Marine Insurance to Rotterdam: USD $850.00
- Total Invoice Value: USD $17,950.00

3. Fast-Track Delivery:
As a VIP client, we can prioritize your order in our premium schedule. Mass production will be completed in 10 working days, and we will handle all booking processes.

Shall we prepare the Proforma Invoice (PI) with our HSBC HK account details to proceed?

Sincerely yours,

Samson Chiu
Sales Manager
Shenzhen Efast Technology Co., Ltd.
E-mail: samson@efast-tech.com`;
    } else {
        draftText = `Dear ${buyerName},

Thank you very much for your inquiry on Alibaba.com regarding our ${productName}.

We are pleased to offer you our professional quotation:

1. Product Pricing & Quality:
Our phone holder products are manufactured strictly under ISO 9001 and ISO 2859-1 standards. We use high-precision molds to guarantee premium durability.
- Target Quantity: 1,500 - 2,000 Units
- Special FOB Shenzhen Price: USD $7.50 / Unit
- Extra Shipping & Handling: Calculated based on your preferred shipping method (DDP / FOB).

2. Terms of Payment:
30% advance deposit via T/T to our HSBC Hong Kong bank account, and 70% balance against inspection report before loading.

Would you like to review our full catalog or have a sample shipped to check the quality first?

Best regards,

Samson Chiu
Shenzhen Efast Technology Co., Ltd.
Email: samson@efast-tech.com`;
    }

    document.getElementById("ai-quote-text").value = draftText;
    modal.classList.add("active");
}

function closeAiQuote() {
    const modal = document.getElementById("ai-quote-modal");
    if (modal) modal.classList.remove("active");
}

function sendAiQuote() {
    const textarea = document.getElementById("ai-quote-text");
    if (!textarea) return;

    navigator.clipboard.writeText(textarea.value).then(() => {
        alert("🎉 [Efast AI 智能开发信] 已经成功复制到剪贴板！\n\n您可以直接粘贴发送至旺旺、阿里后台或 Foxmail 邮箱。预计客户转化成交率提升30%以上。");
        closeAiQuote();
    }).catch(err => {
        alert("复制失败，请手动选择全部文本复制。");
    });
}

/**
 * ==========================================
 * 5. 重点定制专案进度推进与AQL计算 (Project Tracking)
 * ==========================================
 */
const projectProgress = {
    1: { currentStep: 4, client: "Dieter Weber", totalSteps: 7 },
    2: { currentStep: 5, client: "John Miller", totalSteps: 7 }
};



window.openAiQuote = openAiQuote;
export { initChat, renderChatMessages };
